import { REQUEST_STATUS_COMPLETED } from '../../../../../share/util/api/polling';
import session from '../../../../../share/session';
import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import requirement045Utils from './Requirement045Utils';

/**
 * DefaultSession遷移処理
 * @param {instance} self 呼び出し元this
 * @param {number} existence 0:エラー遷移あり, 1:エラー遷移なし
 * @param {number} transitionDestination 0:機能終了,1:呼び出し元の次の処理を実行
 * @param {boolean} loadingOff falseならばスピナーOFFしない
 * @param {boolean} isImmediate エラー即時実行フラグ
 * @returns {boolean} 成否
 */
export async function defaultSessionProcess(
  self,
  existence,
  transitionDestination,
  loadingOff,
  isImmediate
) {
  try {
    self.isLoading = true;
    // 初期化
    await self.dataMonitor.initialize();
    //バックエンドAPI POST,GET(呼び出し時にNonDefaultSessionの場合のみ実行)
    let response = {};
    if (self.isNonDefaultSession) {
      const token = session.getToken();
      response = await individualWorkSupportUtil.pollingWspApi(
        self,
        self.netAppId,
        self.systemId,
        self.workSupportId,
        {
          id_token: token.id_token,
          type: 'exit'
        },
        // エラー発生のコールバックを実装
        // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
        (errorType) => { errorType; self.validateErrorResult({ causeType: 8 }, isImmediate); }, // other error
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
        (result) => { self.validateErrorResult(result, isImmediate); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
        (result) => { self.validateErrorResult(result, isImmediate); },
      );
    } else {
      // 呼び出し時にDefaultSessionだった場合
      if (transitionDestination === 0) self.closeWizard();
      return true;
    }
    // エラー遷移なし
    if (existence === 1) {
      self.closeWizard();
      return true;
    }
    // エラー遷移あり
    if (response) {
      if (response.data.status === REQUEST_STATUS_COMPLETED) {
        if (transitionDestination === 0) self.closeWizard();
        return true;
      }
      throw new Error('Unexpected error occurred: ', response.data?.status);
    }
    return false;
  } catch (error) {
    const result = {
      causeType: "callAPIExceptionHandler",
      exceptionHandlerArgs: [requirement045Utils.METHODS.DEFAULT_SESSION_PROCESS, error, self]
    };
    await self.validateErrorResult(result, isImmediate);
    return false;
  } finally {
    requirement045Utils.terminationHandler(self, loadingOff);
  }
}

export default {
  defaultSessionProcess
};